import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';
import { IProcessListPayload, IProcessListResponse } from '../../processes/models/processes.models';

@Injectable({
	providedIn: 'root',
})
export class PanelProcessesService extends ApiService {
	/** Única fuente de listado panel (En curso / Pendiente): mismo contrato que listado de procesos. */
	public listProcesses(body?: IProcessListPayload): Observable<IProcessListResponse> {
		return this.http.post<IProcessListResponse>(environment.apiUrl + `/processes`, body, {
			headers: this.getHeaders(),
		});
	}
}
